export const SEND_START = "purchase-send/SEND_START";
export const SEND_COMPLETED = "purchase-send/SEND_COMPLETED";
export const SEND_FAILED = "purchase-send/SEND_FAILED";

export const SET_SEND_MODAL_STATE = "purchase-send/SET_SEND_MODAL_STATE";
export const SET_UPDATE_METHODS = "purchase-send/SET_UPDATE_METHODS";
